// @flow

const getSessionToken = (): any => {
    return new Promise((resolve: any, reject: any): any => {
        // Fetch token
        fetch("/session/token")
            .then((res: any): any => res.text())
            .then((data: any): any => {
                resolve(data);
            })
            .catch(err => {
                console.log(err);
                reject(err);
            });
    });
};

export default getSessionToken;
